@if (shouldShowParticipantRubric()) {
	<div class="participant-rubric-setting">
		@if (!selectedParticipantRubric) {
			<button
				type="button"
				class="link-btn add-btn participant-rubric-setting__add-btn"
				[disabled]="isRubricSelectionUnavailable()"
				[matTooltip]="'activity-editor-new_participant-rubric-unavailable' | translate"
				[matTooltipDisabled]="!isRubricSelectionUnavailable()"
				disabledInteractive
				(click)="openRubricSelector()">
				<span translate="activity-editor-new_student-rubrics-label"></span>
			</button>
		} @else {
			<ngx-panel class="participant-rubric-setting__panel">
				<panel-heading>
					<div class="title ellipsis">
						@if (isParticipantRubricLoading) {
							<span class="ficon-spinner ficon-spin" aria-hidden="true"></span>
						} @else {
							<span translate="activity-editor-new_student-rubrics"></span>
						}
					</div>
					<ngx-toolbar>
						<ngx-toolbar-button
							[disabled]="isParticipantRubricLoading"
							[ariaLabel]="'common_preview' | translate"
							[action]="toolbarActions.PREVIEW"
							(clicked)="previewParticipantRubric()">
						</ngx-toolbar-button>
						<ngx-toolbar-button
							[disabled]="isParticipantRubricLoading"
							[ariaLabel]="'common_edit' | translate"
							[action]="toolbarActions.EDIT"
							(clicked)="editParticipantRubric()">
						</ngx-toolbar-button>
						<ngx-toolbar-button
							[disabled]="isParticipantRubricLoading"
							[ariaLabel]="'common_delete' | translate"
							[action]="toolbarActions.REMOVE"
							(clicked)="removeParticipantRubric()">
						</ngx-toolbar-button>
					</ngx-toolbar>
				</panel-heading>

				<panel-body>
					<span>{{ selectedParticipantRubric.title || ('common_untitled' | translate) }}</span>
				</panel-body>
			</ngx-panel>
		}
	</div>
}
